import { ScreenPathPoint } from '@app/Screens/types';

export interface TrailRun {
  /** Inclusive index of the first breadcrumb in this run. */
  start: number;
  /** Inclusive index of the last breadcrumb in this run. */
  end: number;
}

export interface TrailSegmentation {
  /** Contiguous runs of breadcrumbs with no internal gap. */
  runs: TrailRun[];
  /** Index `i` of each segment (i → i+1) whose time delta exceeds the threshold. */
  gapStarts: number[];
}

/**
 * Split a breadcrumb trail into contiguous runs, breaking wherever two
 * consecutive fixes are more than `gapMs` apart in time. Invalid/unordered
 * timestamps are never treated as a gap, so bad data doesn't produce false
 * breaks. Always returns at least one run for a non-empty path.
 */
export function segmentTrail(path: ScreenPathPoint[], gapMs: number): TrailSegmentation {
  const runs: TrailRun[] = [];
  const gapStarts: number[] = [];
  if (path.length === 0) return { runs, gapStarts };
  let start = 0;
  for (let i = 0; i < path.length - 1; i++) {
    const dt = new Date(path[i + 1].recordedAt).getTime() - new Date(path[i].recordedAt).getTime();
    if (Number.isFinite(dt) && dt > gapMs) {
      runs.push({ start, end: i });
      gapStarts.push(i);
      start = i + 1;
    }
  }
  runs.push({ start, end: path.length - 1 });
  return { runs, gapStarts };
}
